import { useStore } from '@nanostores/react';
import { memo } from 'react';
import { PricingHeader } from './PricingHeader';
import { UpdatePlanScreenDialog } from '~/components/dialogs/UpdatePlanScreenDialog/UpdatePlanScreenDialog';
import { FAQ } from '~/components/ui/FAQ';
import { PricingCards } from '~/components/ui/pricing/PricingCards';
import { usePaymentIntentStatusMessage } from '~/lib/hooks/usePaymentIntentStatusMessage';
import { pricingStore } from '~/lib/stores/pricing/pricing';
import { classNames } from '~/utils/classNames';

export const Pricing = memo(({ className }: { className?: string }) => {
  const updatePlanScreenData = useStore(pricingStore.updatePlanScreenData);
  usePaymentIntentStatusMessage();

  return (
    <div className={classNames('mx-auto max-w-7xl w-full flex flex-col gap-8 px-4 md:px-10 pb-10 xl:px-6', className)}>
      <UpdatePlanScreenDialog open={!!updatePlanScreenData} />

      <PricingHeader />

      <PricingCards />

      <FAQ />
    </div>
  );
});
